import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable} from 'rxjs';
import { LocalStorageService } from './local-storage.service';
import { HttpClient } from '@angular/common/http';
import { UrlParams } from 'src/app/constants/URL_PARAMS';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  private currentUserSubject: BehaviorSubject<UserDetails>;
  public currentUser: Observable<UserDetails>;
  

  constructor(private http: HttpClient, private storage: LocalStorageService) {
    this.currentUserSubject = new BehaviorSubject<UserDetails>(this.storage.getUserInfo());
    this.currentUser = this.currentUserSubject.asObservable();
  } 

  public get currentUserValue(): UserDetails {
    return this.currentUserSubject.value;
  }

  postUserRegistration(userRegister :any): Observable<any>{
    const url = `${UrlParams.LOGIN.USER_REGISTRATION}`;
    return this.http.post<any>(url,userRegister);
  }
  checkUserExist(userEmail:any): Observable<any>{
    const url = `${UrlParams.LOGIN.CHECK_USER}/${userEmail}`;
    return this.http.get<any>(url);
  }
  postUserLogin(userDetail :any): Observable<any>{
    const url = `${UrlParams.LOGIN.USER_LOGIN}`;
     
    return this.http.post<any>(url,userDetail)
    .pipe(map(user => {
      if (user && user.data) {
        this.storage.setUserInfo(user);
        this.currentUserSubject.next(user.data);
      }
      return user.data;
    }));
  }

  getForgetPassword(email:string): Observable<any>{
    const url = `${UrlParams.LOGIN.FORGET_PASSWORD}/${email}`;
    return this.http.get<any>(url);
  }

  postResetPassword(otpDetail :any): Observable<any>{
    const url = `${UrlParams.LOGIN.RESET_PASSWORD}`;
    return this.http.post<any>(url,otpDetail);
  }

  postChangePassword(passDetails :any): Observable<any>{
    const url = `${UrlParams.LOGIN.CHANGE_PASSWORD}`;
    return this.http.post<any>(url,passDetails);
  }

  logout() {
    this.storage.emptyLocalStorage();
    var obj = new UserDetails();
    this.currentUserSubject.next(obj);
    window.location.reload();
  }
}

export class UserDetails{
  constructor(
      public userName : string = '',
      public firstName : string = '',
      public lastName : string = '',
      public company : string = '',
      public role : string = '',
      public emailId : string = '',
      public tokenId : string = ''

      ){}
}
